import React from "react";
import Slider from "react-slick";
import AllEarningCard from "../../card/earning/AllEarningCard";
import { TableCellsIcon } from "@heroicons/react/24/outline";
import "./slider.css";
import NextArrow from "./NextArrow";
import PreArrow from "./PreArrow";

const HistoryIcon = (
  <div style={{ marginRight: "5px" }}>
    {" "}
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C4.46667 12 3.13044 11.4916 1.99133 10.4747C0.852222 9.45778 0.199556 8.18844 0.0333333 6.66667H1.4C1.55556 7.82222 2.06956 8.77778 2.942 9.53333C3.81444 10.2889 4.83378 10.6667 6 10.6667C7.3 10.6667 8.40289 10.2138 9.30867 9.308C10.2144 8.40222 10.6671 7.29956 10.6667 6C10.6667 4.7 10.2138 3.59711 9.308 2.69133C8.40222 1.78556 7.29956 1.33289 6 1.33333C5.23333 1.33333 4.51667 1.51111 3.85 1.86667C3.18333 2.22222 2.62222 2.71111 2.16667 3.33333H4V4.66667H0V0.666667H1.33333V2.23333C1.9 1.52222 2.59178 0.972222 3.40867 0.583333C4.22556 0.194444 5.08933 0 6 0C6.83333 0 7.614 0.158444 8.342 0.475333C9.07 0.792222 9.70333 1.21978 10.242 1.758C10.7807 2.29711 11.2084 2.93044 11.5253 3.658C11.8422 4.38556 12.0004 5.16622 12 6C12 6.83333 11.8416 7.614 11.5247 8.342C11.2078 9.07 10.7802 9.70333 10.242 10.242C9.70289 10.7807 9.06955 11.2084 8.342 11.5253C7.61444 11.8422 6.83378 12.0004 6 12ZM7.86667 8.8L5.33333 6.26667V2.66667H6.66667V5.73333L8.8 7.86667L7.86667 8.8Z"
        fill="#2563EB"
      />
    </svg>
  </div>
);

function CardSlider({ handleClickOpen,earning, requestRaised, requestRaisedMessage }) {
  const setting = {
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PreArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToScroll: 1,
        },
      },
    ],
  };
  const data = [
    {
      title: "Projected earning ",
      rupee: `₹ ${earning?.projected_earning?.projected_amount?.toLocaleString('en-IN') ?? "----"}`,
      color: "#2563EB",
      desColor: "#6C757D",
      des: `Assigned ${ earning?.projected_earning?.job_accepted_count ?? 0} jobs`,
    },
    {
      title: "Net earning",
      rupee: `₹ ${earning?.net_earning?.joined_amount?.toLocaleString('en-IN') ?? "----"}`,
      color: "#2563EB",
      desColor: "#6C757D",
      des: `Joined ${earning?.net_earning?.joined_candidate_count ?? 0} candidates`,
    },
    {
      title: "Mature earning",
      rupee: `₹ ${earning?.matured_earning?.matured_amount?.toLocaleString('en-IN') ?? "----"}`,
      color: "#2563EB",
      desColor: "#6C757D",
      des: `Mature ${earning?.matured_earning?.matured_candidate_count ?? 0 } candidates`,
    },
    {
      title: "Withdrawable",
      rupee: `₹ ${earning?.withdrawable_earning?.withdrawable_amount?.toLocaleString('en-IN') ?? "----"}`,
      color: "#2563EB",
      desColor: "#6C757D",
      color: "#0DA06A",
      message: (earning?.withdrawable_earning?.withdrawable_amount > 0) ? earning?.withdrawable_earning?.message : "" ,
      disbaled: (earning?.withdrawable_earning?.withdrawable_amount > 0) ? earning?.withdrawable_earning?.is_raised_request : true
    },
    {
      title: "Total Withdrawn",
      rupee: `₹ ${earning?.total_withdrawn_amount?.toLocaleString('en-IN') ?? "-----"}`,
      color: "#EF4444",
      des: "Check history",
      link: "/history",
      desColor: "#2563EB",
      desIcon: HistoryIcon,
    },
  ];
  
  return (
    <div className="relative w-full ">
      <Slider {...setting}>
        {data.map((item, i) => (
          <div key={i} className="w-full">

            {(item.title === "Withdrawable")?(<AllEarningCard
              handleClickOpen={handleClickOpen}
              requestRaised={requestRaised}
              requestRaisedMessage={requestRaisedMessage}
              title={item.title}
              rupee={item.rupee}
              color={item.color}
              des={item.des}
              link={item.link}
              desColor={item.desColor}
              desIcon={item.desIcon}
              message={item.message}
              disabled={item.disbaled}
              // item = {item}
            />):(<AllEarningCard
              handleClickOpen={handleClickOpen}
              title={item.title}
              rupee={item.rupee}
              color={item.color}
              des={item.des}
              link={item.link}
              desColor={item.desColor}
              desIcon={item.desIcon}
            />)}
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default CardSlider;

